import { Outlet } from 'react-router'
import { AudioStepIndicator } from '#app/components/audio-step-indicator.tsx'

export default function EditorLayout() {
	return (
		<div className="mx-auto w-full max-w-3xl space-y-6 p-4">
			<div className="mx-auto flex justify-center items-center">
					{/* <h1 className="font-sans text-4xl font-extrabold tracking-tight">
				Podly
			</h1> */}
					<AudioStepIndicator />
				</div>
				<Outlet />
			</div>
		)
}
